var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHkid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2832",
    "data-name": "Rectangle 2832",
    width: 9.012,
    height: 5.007,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27005",
    "data-name": "Group 27005",
    transform: "translate(-76 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    transform: "translate(76 237)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27003",
    "data-name": "Group 27003",
    transform: "translate(-130 -42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2833",
    "data-name": "Rectangle 2833",
    d: "M1.778.889a.89.89,0,0,0-.889.889V14.222a.89.89,0,0,0,.889.889H24a.89.89,0,0,0,.889-.889V1.778A.89.89,0,0,0,24,.889H1.778m0-.889H24a1.778,1.778,0,0,1,1.778,1.778V14.222A1.778,1.778,0,0,1,24,16H1.778A1.778,1.778,0,0,1,0,14.222V1.778A1.778,1.778,0,0,1,1.778,0Z",
    transform: "translate(213 291)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27000",
    "data-name": "Group 27000",
    transform: "translate(216.004 294.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    d: "M2.222.889A1.333,1.333,0,1,0,3.556,2.222,1.335,1.335,0,0,0,2.222.889m0-.889A2.222,2.222,0,1,1,0,2.222,2.222,2.222,0,0,1,2.222,0Z",
    transform: "translate(2.329 0)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23904",
    "data-name": "Mask Group 23904",
    transform: "translate(0 4.9)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2831",
    "data-name": "Rectangle 2831",
    d: "M2.667.889A1.78,1.78,0,0,0,.889,2.667V7.111A1.78,1.78,0,0,0,2.667,8.889H6.222A1.78,1.78,0,0,0,8,7.111V2.667A1.78,1.78,0,0,0,6.222.889H2.667m0-.889H6.222A2.667,2.667,0,0,1,8.889,2.667V7.111A2.667,2.667,0,0,1,6.222,9.778H2.667A2.667,2.667,0,0,1,0,7.111V2.667A2.667,2.667,0,0,1,2.667,0Z",
    transform: "translate(0.107 0.433)",
    fill: "#1c1c1c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27001",
    "data-name": "Group 27001",
    transform: "translate(227.376 296.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_307",
    "data-name": "Line 307",
    d: "M7.2-.111H-.556A.444.444,0,0,1-1-.556.444.444,0,0,1-.556-1H7.2a.444.444,0,0,1,.444.444A.444.444,0,0,1,7.2-.111Z",
    transform: "translate(1 1)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_308",
    "data-name": "Line 308",
    d: "M7.2-.111H-.556A.444.444,0,0,1-1-.556.444.444,0,0,1-.556-1H7.2a.444.444,0,0,1,.444.444A.444.444,0,0,1,7.2-.111Z",
    transform: "translate(1 3.736)",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkid);
export default __webpack_public_path__ + "static/media/hkid.16184769f05d219bbcee2f1b6c23bb32.svg";
export { ForwardRef as ReactComponent };